<div class="caption">
  <div class="caption-subject bold">
    <i class="fal {{icon}}"></i> <span>{{ title | translate:locale.language}}</span>
  </div>
</div>

